<template>
  <div class="contentarea">
    <component
      v-bind:is="computed_title_field_tag"
      v-bind:class="`contentarea__title ` + computed_title_field_tag"
      v-if="content && content[computer_prefix + `content_title`]"
      v-html="content[computer_prefix + 'content_title']"
    ></component>
    <div
      class="contentarea__copy"
      v-if="content"
      v-html="content[computer_prefix + `content_copy`]"
    ></div>

    <div v-if="content.service_item_one_title && content.service_item_one_link" class="contentarea__copy contentarea__copy--newcontent">
      <a :href="content.service_item_one_link.url" :title="content.service_item_one_link.title">
        <span class="prependIcon">
          <img src="/app/themes/redbeemedia/images/title-logo.svg" alt="redbee">
        </span>
        <h1>{{content.service_item_one_title}}</h1>
      </a>
      <p>{{content.service_item_one_text}}</p>
    </div>

    <div v-if="content.service_item_two_title && content.service_item_two_link" class="contentarea__copy contentarea__copy--newcontent">
      <a :href="content.service_item_two_link.url" :title="content.service_item_two_link.title">
        <span class="prependIcon">
          <img src="/app/themes/redbeemedia/images/title-logo.svg" alt="redbee">
        </span>
        <h1>{{content.service_item_two_title}}</h1>
      </a>
      <p>{{content.service_item_two_text}}</p>
    </div>
    <div
      class="contentarea__links"
      v-if="content && content[computer_prefix + `content_links`]"
    >
      <a
        v-for="(link, index) in content[computer_prefix + `content_links`]"
        v-bind:key="'link_' + index"
        v-bind:href="link.link.url"
        v-bind:title="link.link.title"
        v-bind:target="link.link.target"
        v-bind:class="link.display_as_button ? `btn btn-primary` : ``"
      >
        {{ link.link.title }}
      </a>
    </div>
  </div>
</template>
<script>
export default {
  props: ["content", "prefix", "title_field_tag"],
  computed: {
    computed_title_field_tag: function() {
      return this.title_field_tag ? this.title_field_tag : "h2";
    },
    computer_prefix() {
      return this.prefix ? this.prefix : "";
    }
  }
};
</script>
